import React from 'react';
import Menu from '../components/menu/menu.jsx';
import Content from '../components/content/content.jsx';

function NotFound() {
  return (
    <div>
      <Menu />
      <Content>
        <h1>404 - Page Not Found</h1>
        <br></br>
        <h2>Project in progress!!</h2>
        <br></br>
        <p>Sorry, the page you are looking for does not exist!</p>        
        <p>But we are still working hard to provide you with new content!</p>
        <p>Stay tuned for updates!</p>
        <p>In the meantime, you can go back to the <a href="/">home page</a>.</p>
        <p>Thank you for your understanding!</p>
      </Content>
    </div>
  );
}

export default NotFound;